export const STRIPE_PRE_PAY = 'cdb/payment/stripe/prepay'
export const STRIPE_RECHARGE = 'cdb/payment/stripe/recharge'
export const STRIPE_PAY_OF_CONFIRM = 'cdb/payment/stripe/prepayOfConfirm'
export const STRIPE_RECHARGE_OF_CONFIRM = 'cdb/payment/stripe/rechargeOfConfirm'
export const STRIPE_PAY_CONFIRM = 'cdb/payment/stripe/payConfirm'
export const STRIPE_PREAUTH_OF_CONFIRM = 'cdb/payment/stripe/preauthOfConfirm'
export const STRIPE_PREAUTH_AUTO_CONFIRM = 'cdb/payment/stripe/authConfirm'

export const PAYPAL_PRE_PAY = 'cdb/payment/paypal/v2/prepay' // 充值押金或充值并租借
export const PAYPAL_RECHARGE = 'cdb/payment/paypal/v2/recharge' // 充值余额或充值并租借
export const PAYPAL_VIPORDER = 'cdb/payment/paypal/v2/vipOrder'
export const PAYPAL_PAYORDER = 'cdb/payment/paypal/v2/payOrder'
export const PAYPAL_PAYCONFIRM = 'cdb/payment/paypal/v2/payConfirm'
export const PAYPAL_BUYCOUPON = 'cdb/payment/paypal/v2/buyCoupon'
export const PAYPAL_EXC_PAY = 'cdb/payment/paypal/excpay'

export const WECHAT_MP_PRE_PAY = 'cdb/payment/wechat_mp/prepay'
export const ALIPAY_PRE_PAY = 'cdb/payment/alipay/prepay'

export const WECHAT_MP_RECHARGE = 'cdb/payment/wechat_mp/recharge'

export const YEDPAY_RECHARGE = 'cdb/payment/yedpay/recharge'
export const YEDPAY_PREPAY = 'cdb/payment/yedpay/prepay'
export const YEDPAY_PAY_CONFIRM = 'cdb/payment/yedpay/payConfirm'
export const YEDPAY_PREPAY_RENT = 'cdb/payment/yedpay/rent'
export const YEDPAY_PAY_ORDER = 'cdb/payment/yedpay/payOrder'
export const VIP_ORDER = 'cdb/payment/yedpay/vipOrder' // yedpay购买vip
export const YEDPAY_PAY_COUPON = 'cdb/payment/yedpay/buyCoupon'

export const TIXIAN_YAJIN = 'cdb/mine/tixian/yajin'
export const TIXIAN_APPLY = 'cdb/mine/yajin/apply'
export const TIXIAN_RECHARGE = 'cdb/mine/recharge/apply'
export const CREATE_VIP_ORDER = 'cdb/cabinet/createorderByVip'
export const CDY_REMART_HOME = 'cdb/payment/cdymart/home'
export const WEPAYEZ_PREPAY = 'cdb/payment/wepayez/prepayWithNative'
export const WEPAYEZ_PAYCONFIRM = 'cdb/payment/wepayez/payConfirmWithNative'
export const WEPAYEZ_COUPONCD = 'cdb/payment/wepayez/buyCouponWithNative'
export const WEPAYEZ_VIPORDER = 'cdb/payment/wepayez/vipOrderWithNative'
// eft 支付
export const EFTPAY_COUPON = 'cdb/payment/eftPay/buyCoupon' // eft购买充电券
export const EFTPAY_VIP_ORDER = 'cdb/payment/eftPay/vipOrder' // eft购买vip
export const EFT_PREPAY_RENT = 'cdb/payment/eftPay/rent' // eft押金租借
export const EFT_PREPAY = 'cdb/payment/eftPay/prepay' // eft充值押金、租借
export const EFT_RECHARGE = 'cdb/payment/eftPay/recharge' // eft充值余额、租借
export const EFT_PAY_ORDER = 'cdb/payment/eftPay/payOrder' // eft订单付款
export const EFT_PAY_CONFIRM = 'cdb/payment/eftPay/payConfirm' // eft确认订单是否付款
// mpay 支付
export const MPAY_PREPAY = 'cdb/payment/mPay/prepay'
export const MPAY_RECHARGE = 'cdb/payment/mPay/recharge'
export const MPAY_RENT = 'cdb/payment/mPay/rent'
export const MPAY_PAY_ORDER = 'cdb/payment/mPay/payOrder'
export const MPAY_VIP_ORDER = 'cdb/payment/mPay/vipOrder'
export const MPAY_BUY_COUPON = 'cdb/payment/mPay/buyCoupon'
export const MPAY_PAY_CONFIRM = 'cdb/payment/mPay/payConfirm'

// 微信支付
export const WX_PAY = 'cdb/payment/wxh5pay/recharge' // 充值押金、租借
export const WX_PAY_RECHARGE = 'cdb/payment/wxh5pay/rechargeNew' // 充值余额、租借
export const WX_PAY_CONFIRM = 'cdb/payment/wxh5pay/payment/confirm'

export const PAYMENT_CONFIG = 'cdb/dailiPaymentConfig/queryAll'
